module.exports = __webpack_public_path__ + "img/case5.dc313d78.png";